import { getRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function getSavedOrderSearchCountRequest(id) {
	let url = savedOrderSearches.getCountByIdPath(id);
	let response = await getRequest(url);
	return response;
}
